export default "b43ae055bc084773.png"